const CALLBACK_TYPE_GET_LIST_METADATA = "get_list_metadata";
const CALLBACK_TYPE_GET_LIST_HOTELS = "get_list_hotels_v4";
const CALLBACK_TYPE_GET_HOTEL_DETAIL = "get_hotel_details";
const GET_LIST_HOTEL_TAB = "get_list_hotel_tab_detail";
const CALLBACK_TYPE_GET_ROOMS_BY_HOTEL_v2 = "get_list_hotel_rooms_v2";
const CALLBACK_TYPE_GET_ROOMS_BY_HOTEL = "get_list_hotel_rooms_v4";
const CALLBACK_TYPE_GET_PLANS_BY_HOTEL_v2 = "get_list_hotel_plans_v2";
const CALLBACK_TYPE_GET_PLANS_BY_HOTEL = "get_list_hotel_plans_v4";
const CALLBACK_TYPE_GET_CART_DETAIL = "get_cart_detail_v4";
const CALLBACK_TYPE_CREATE_ORDER = "create_reservation_v4";
const CALLBACK_TYPE_GET_LIST_ORDERS = "get_list_orders";
const CALLBACK_TYPE_GET_ORDERS_DETAIL = "get_order_detail";
const CALLBACK_TYPE_SEARCH_LIST_METADATA = "search_list_metadata";
const CALLBACK_TYPE_GET_LIST_THEMES = "get_list_themes";
const CALLBACK_TYPE_GET_ROOM_DETAIL = "get_room_details";
const CALLBACK_TYPE_GET_ROOM_DETAIL_v2 = "get_room_details_v2";
const CALLBACK_TYPE_GET_PRICE_ROOM_PLAN = "get_room_plan_amount";
const CALLBACK_TYPE_GET_ROOM_SUGGESTION = "get_list_suggested_rooms";
const CALLBACK_TYPE_GET_ROOM_NFT = "get_list_nft_rooms";
const CALLBACK_TYPE_GET_LIST_RESALE_ORDERS = "get_resale_list";
const CALLBACK_TYPE_GET_DETAIL_RESALE_ORDER = "get_product_details";
const CALLBACK_TYPE_GET_LIST_RESALE_ORDERS_BY_SALLER = "get_user_products";
const CALLBACK_TYPE_GET_LIST_RESALE_EXPIRED = "get_list_nearly_expired_product";
const CALLBACK_TYPE_LOGIN = "sign_in";
const CALLBACK_TYPE_LOGIN_WITH_FACEBOOK = "sign_in_with_facebook";
const CALLBACK_TYPE_LOGIN_WITH_GOOGLE = "sign_in_with_google";
const CALLBACK_TYPE_REGISTER = "sign_up";
const CALLBACK_TYPE_GET_USER_PROFILE = "get_user_info";
const CALLBACK_TYPE_CREATE_RESALE_ORDER = "create_resale_order";
const CALLBACK_TYPE_CREATE_BY_RESALE_ORDER = "create_buy_resale_order";
const CALLBACK_TYPE_LIST_USER_RESERVATION = "get_list_user_reservations";
const CALLBACK_TYPE_GET_USER_INFO_BY_ID = "get_user_info_by_id";
const CALLBACK_TYPE_GET_LIST_AVAILABLE_ROOMS = "get_list_available_rooms";
export const CALLBACK_TYPE_GET_VIEWED_HOTELS = "get_viewed_hotels";
export const CALLBACK_TYPE_ADD_VIEWED_HOTEL = "add_viewed_hotel";
export const CALLBACK_TYPE_SEARCH_METADATA_BY_ZONE = "get_metadata_by_zone";
export const CALLBACK_TYPE_GET_UPLOAD_IMAGE_URL = "get_upload_image_url";
export const CALLBACK_TYPE_DELETE_IMAGE = "delete_image";
export const CALLBACK_TYPE_UPDATE_PRODUCT = "update_product";
export const CALLBACK_TYPE_GET_CALENDAR_PRICE_BY_HOTEL =
  "get_calendar_price_by_hotel_v4";
export const CALLBACK_TYPE_FORGOT_PASSWORD = "forgot_password";
export const CALLBACK_TYPE_RESET_PASSWORD = "reset_password";
export const CALLBACK_TYPE_UPDATE_USER_PROFILE = "update_user_info";
export const CALLBACK_TYPE_UPDATE_USER_PASSWORD = "update_user_password";
export const CALLBACK_TYPE_GET_URL_UPLOAD = "get_url_upload_image";
export const CALLBACK_TYPE_UPDATE_USER_AVATAR_PROFILE =
  "update_user_avatar_profile";
export const CALLBACK_TYPE_USER_POST_REVIEW = "user_post_review";
export const CALLBACK_TYPE_USER_BANK_INFO = "update_user_bank_info";
export const CALLBACK_TYPE_USER_WITHDRAW = "user_withdraw_price";
export const CALLBACK_TYPE_USER_LIST_ORDERS = "user_get_history_transaction";
export const CALLBACK_TYPE_USER_LIST_ORDERS_V2 =
  "user_get_history_transaction_v2";
export const CALLBACK_TYPE_USER_CHECK_REGISTER = "user_check_register";
export const CALLBACK_TYPE_USER_TEST_STRIPE = "test_stripe";
export const CALLBACK_TYPE_USER_TEST_STRIPE_CHARGE = "test_stripe_charge";
export const CALLBACK_TYPE_GET_CARD_TOKEN = "get_token_card";
export const LINK_SOCIAL_NETWORK = "link_account_social_network";
export const UNLINK_SOCIAL_NETWORK = "unlink_account_social_network";
export const CREATE_SELLER_REVIEW = "create_seller_review";
export const CALLBACK_TYPE_GET_INFO_BY_POSTAL_CODE = "get_address_by_postal_code";
export const CALLBACK_TYPE_VALIDATE_RESET_PASSWORD_CODE = "validate_reset_password_code";

export {
  CALLBACK_TYPE_GET_LIST_METADATA,
  CALLBACK_TYPE_GET_LIST_HOTELS,
  CALLBACK_TYPE_GET_HOTEL_DETAIL,
  CALLBACK_TYPE_GET_ROOMS_BY_HOTEL,
  CALLBACK_TYPE_GET_PLANS_BY_HOTEL,
  CALLBACK_TYPE_CREATE_ORDER,
  CALLBACK_TYPE_GET_LIST_ORDERS,
  CALLBACK_TYPE_GET_ORDERS_DETAIL,
  CALLBACK_TYPE_SEARCH_LIST_METADATA,
  CALLBACK_TYPE_GET_LIST_THEMES,
  CALLBACK_TYPE_GET_ROOM_DETAIL,
  CALLBACK_TYPE_GET_PRICE_ROOM_PLAN,
  CALLBACK_TYPE_GET_ROOM_SUGGESTION,
  CALLBACK_TYPE_GET_ROOM_NFT,
  CALLBACK_TYPE_GET_LIST_RESALE_ORDERS,
  CALLBACK_TYPE_GET_DETAIL_RESALE_ORDER,
  CALLBACK_TYPE_GET_LIST_RESALE_ORDERS_BY_SALLER,
  CALLBACK_TYPE_GET_LIST_RESALE_EXPIRED,
  CALLBACK_TYPE_LOGIN,
  CALLBACK_TYPE_LOGIN_WITH_FACEBOOK,
  CALLBACK_TYPE_LOGIN_WITH_GOOGLE,
  CALLBACK_TYPE_REGISTER,
  CALLBACK_TYPE_GET_USER_PROFILE,
  CALLBACK_TYPE_CREATE_RESALE_ORDER,
  CALLBACK_TYPE_CREATE_BY_RESALE_ORDER,
  CALLBACK_TYPE_LIST_USER_RESERVATION,
  CALLBACK_TYPE_GET_USER_INFO_BY_ID,
  CALLBACK_TYPE_GET_LIST_AVAILABLE_ROOMS,
  CALLBACK_TYPE_GET_ROOMS_BY_HOTEL_v2,
  CALLBACK_TYPE_GET_PLANS_BY_HOTEL_v2,
  CALLBACK_TYPE_GET_ROOM_DETAIL_v2,
  GET_LIST_HOTEL_TAB,
  CALLBACK_TYPE_GET_CART_DETAIL,
};
